export default __webpack_public_path__ + "static/media/cred-icon.1f50909a.svg";